module.exports = __webpack_public_path__ + "static/img/product_head.ab54e17.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_head.gif
// module id = 8zet
// module chunks = 1